import React from "react";
import "./Tabs.scss";

export const Tab = ({ id, className, label, activeId, onClick }) => {
	return (
		<div
			id={id}
			className={`custom-tab ${className ? className : ""}`}
			onClick={() => {
				onClick(id);
			}}
		>
			<div className="text text-body--3 text-bold text-center">{label}</div>
		</div>
	);
};
